import { jsx as e, jsxs as t } from "react/jsx-runtime";
// lib/PrintText/components/TextRole.tsx
var n = ({ children: n }) => /* @__PURE__ */ t("div", {
	className: "border-t flex items-center py-2 text-sm",
	children: [/* @__PURE__ */ e("label", {
		className: "text-sm opacity-70 w-14",
		contentEditable: !1,
		children: "Roll"
	}), /* @__PURE__ */ e("div", { children: n })]
});
export { n as TextRole };
